// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  deleteWrapper,
  fetchWrapper,
  patchWrapper,
  postWrapper,
  postFormDataWrapper,
  putWrapper,
} from 'helpers/api'

export const deletePathCommentById = (pathId, pathCommentId) => (
  deleteWrapper(`/paths/${pathId}/comments/${pathCommentId}`)
)
export const deletePathCommentFile = pathCommentFileId => deleteWrapper(`/path-comment-files/${pathCommentFileId}`)

export const fetchPathById = pathId => fetchWrapper(`/paths/${pathId}`)

export const fetchPathCaseSummary = (pathId, query) => fetchWrapper(`/paths/${pathId}/path-case-summary${query}`)

export const fetchPathChannelCaseSummary = (pathId, query) => (
  fetchWrapper(`/paths/${pathId}/channel-case-summary${query}`)
)

export const fetchPathSummaryById = id => fetchWrapper(`/paths/${id}/summary`)

export const fetchPathsByQuery = q => fetchWrapper(`/paths${q}`)

export const fetchPathCsvImportTypes = () => fetchWrapper('/path-csv-import/import-types')

export const getPathFromSegmentEndId = segmentEndId => fetchWrapper(`/paths/segment-ends/${segmentEndId}`)

export const patchBulkPathEdit = b => patchWrapper('/paths/bulk-path-edit', b)

export const patchBulkSiteEdit = b => patchWrapper('/paths/bulk-site-edit', b)

export const postCopyPath = p => postWrapper(`/paths/copy/${p}`)

export const postDeletePaths = p => deleteWrapper(`/paths?pathDeletes=${p}`)

export const postUndeletePath = p => postWrapper(`/paths/${p}/un-delete`)

export const postFlipPathFrequencies = body => postWrapper('/paths/flip-frequencies-for-analysis', body)

export const postNewPath = p => postWrapper('/paths', p)

export const postPathComment = (pathId, comment) => (
  postFormDataWrapper(`/paths/${pathId}/comments`, comment)
)

// csvData contains the CSV file as well as meta information
// on how to interpret/parse the file.
export const postPathImportCSV = csvData => (
  postFormDataWrapper('/path-csv-import/', csvData)
)

export const postPathReportExport = body => (
  postWrapper('/paths/export-data', body)
)

export const postPathWarnings = pathIds => (
  postWrapper('/paths/warnings', { pathIds })
)

export const postUpdatePolarizations = body => (
  postWrapper('/paths/update-polarizations', body)
)

export const putPathDetails = p => putWrapper('/paths', p)
